<template>
  <div>
    <qx-card title="线路" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box v-for="(data, index) in detailData" :data="data" :key="index">
        <section slot="lineInfo">
          <LineDetail :lineDetail="lineDetail" />
        </section>
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100001"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  customerLineDetail, // 获取详情
} from 'api/archives';
import LineDetail from 'components/lineDetail/lineDetail';
import ApproveBox from 'components/approveBox';
import {mapState} from 'vuex';
export default {
  components: {
    ApproveBox,
    LineDetail,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      pageUrl: '/manage/archives/customer/line/detail',
      loading: false,
      lineDetail: {},
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'lineCodeRule',
                label: '线路编码',
              },
              {
                prop: 'customerName',
                label: '客户全称',
              },
              {
                prop: 'lineName',
                label: '联系人',
              },
              {
                prop: 'lineTel',
                label: '联系手机',
              },
              {
                prop: 'effectBeginName',
                label: '生效日期',
              },
              {
                prop: 'effectEndName',
                label: '有效期至',
              },
              {
                prop: 'stateName',
                label: '线路状态',
              },
              {
                prop: 'saleDaparmentName',
                label: '归属部门',
              },
              {
                prop: 'customerLineNo',
                label: '客户线路编码',
              },
              {
                prop: 'customerTypeName',
                label: '客户类型',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        carInfo: {
          label: '车型及货物信息',
          tableData: {
            title: [
              {
                prop: 'vehicleStatusName',
                label: '车型要求',
              },
              {
                prop: 'goodsWeight',
                label: '重量',
                unit: '吨',
              },
              {
                prop: 'goodsVolume',
                label: '体积',
                unit: '立方',
              },
              {
                prop: 'goodsName',
                label: '货品名称',
              },
              {
                prop: 'goodsTypeName',
                label: '货品类型',
              },
              {
                prop: 'goodsNumber',
                label: '计划数量',
                unit: '件',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        line: {
          label: '线路信息',
          tableData: {
            title: [
              {
                prop: 'lineCodeName',
                label: '线路名称',
              },
              {
                prop: 'taiwanDate',
                label: '发车时间',
              },
              {
                prop: 'cmMileageNumber',
                label: '客户公里数',
                unit: '公里',
              },
              {
                prop: 'mileageNumber',
                label: '承运商公里数',
                unit: '公里',
              },
              {
                prop: 'lineInfo',
                slot: true,
                span: 1,
                lableHide: true,
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        income: {
          label: '收入信息',
          tableData: {
            title: [
              {
                prop: 'priceUnit',
                label: '收入单价',
                unit: '',
              },
              {
                prop: 'estimateIncome',
                label: '预估应收',
                unit: '元',
              },
              {
                prop: 'fullFreight',
                label: '应付运费',
                unit: '元',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        cost: {
          label: '成本信息',
          tableData: {
            title: [
              {
                prop: 'oilCostPer',
                label: '载重油耗',
                unit: '升/百公里',
              },
              {
                prop: 'pontagePer',
                label: '单公里路桥',
                unit: '元/公里',
              },
              {
                prop: 'emptyOilCostPer',
                label: '空载油耗',
                unit: '升/百公里',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        freight: {
          label: '运费信息',
          tableData: {
            title: [
              {
                prop: 'settlementMethodName',
                label: '结算方式',
              },
              {
                prop: 'settlementUnitPrice',
                label: '结算单价',
                unit: '元/吨',
              },
              {
                prop: 'goodsUnitPrice',
                label: '拉运货值',
                unit: '元/吨',
              },
              {
                prop: 'deductionsScale',
                label: '货损扣重比例',
                unit: '‰',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        costOut: {
          label: '外调车及承包车成本（本线路如需外请车，需填写以下两项内容）',
          tableData: {
            title: [
              {
                prop: 'guidePrice',
                label: '运费上限',
                unit: '元',
              },
              {
                prop: 'guideMerchant',
                label: '运费标准',
                unit: '元',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        settlement: {
          label: '结算信息',
          tableData: {
            title: [
              {
                prop: 'payWayName',
                label: '结算方式',
              },
              {
                prop: 'reciveTime',
                label: '回单期限',
              },
              {
                prop: 'collection',
                label: '收款期限',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        other: {
          label: '其他',
          tableData: {
            title: [
              {
                prop: 'remarks',
                label: '备注',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息

    }),
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  // watch: {
  //   '$route': async function (newVal, oldVal) {
  //     if (oldVal.path === newVal.path) {
  //       this.getData();
  //     }
  //   },
  // },
  methods: {
    // 统一设置线路信息的数据格式，提供给组件使用
    setLineDetail (detailRes) {
      // 详情数据
      const data = detailRes.cmCustomerLineData || {};
      // 提交审核的详情数据
      const ver = detailRes.cmCustomerLineAuthData || {};

      data.subWayList.forEach((item) => {
        item.nand = item.desNand;
        item.eand = item.desEand;
      });

      ver.subWayList.forEach((item) => {
        item.nand = item.desNand;
        item.eand = item.desEand;
      });

      const lineDetail = {
        data: {
          // 出发导航地址
          navigatSourceLocation: data.navigatSourceLocation || '',
          // 出发地址
          source: data.source || '',
          // 目的导航地址
          navigatDesLocation: data.navigatDesLocation || '',
          // 目的地址
          desAddress: data.desAddress || '',
          // 到达时间
          arriveTime: data.arriveTime || '',
          // 途径地址
          subWayList: data.subWayList || [],

          // 出发地经度
          nand: data.sourceNand,
          // 出发地纬度
          eand: data.sourceEand,
          // 目的地地经度
          nandDes: data.desNand,
          // 目的地纬度
          eandDes: data.desEand,
        },
        ver: {
          // 出发导航地址（审核）
          navigatSourceLocation: ver.navigatSourceLocation || '',
          // 出发地址（审核）
          source: ver.source || '',
          // 目的导航地址（审核）
          navigatDesLocation: ver.navigatDesLocation || '',
          // 目的地址（审核）
          desAddress: ver.desAddress || '',
          // 到达时间（审核）
          arriveTime: ver.arriveTime || '',
          // 途径地址（审核）
          subWayList: ver.subWayList || [],

          // 出发地经度
          nand: ver.sourceNand,
          // 出发地纬度
          eand: ver.sourceEand,
          // 目的地地经度
          nandDes: ver.desNand,
          // 目的地纬度
          eandDes: ver.desEand,
        },

      };
      return lineDetail;
    },
    // 重置审核数据，防止切换tab的时候用其他页面的数据和此页面数据作对比
    resetApproveData () {
      this.lineDetail = {};
      for (let item in this.detailData) {
        if (this.detailData[item]) {
          this.detailData[item].tableData.approveData = {};
        }
      }
    },
    async getData () {
      if (this.$route.path !== '/manage/archives/customer/line/detail' && !this.id) {
        return;
      }
      this.resetApproveData();
      this.loading = true;
      this.detailData.line.tableData.title = this.detailData.line.tableData.title.filter((item) => item.tag !== 'middle');
      const detailRes = await customerLineDetail({
        lineId: this.id || this.$route.query.id,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        if (detailRes.code && detailRes.code === 202) {
          this.$message({
            type: 'warning',
            message: detailRes.msg,
          });
          this.close();
        } else {


          this.lineDetail = this.setLineDetail(detailRes);
          detailRes.cmCustomerLineData.settlementMethod = '按卸货重量';
          detailRes.cmCustomerLineData.goodsUnitPrice = detailRes.cmCustomerLineData.goodsUnitPrice / 100;
          detailRes.cmCustomerLineData.settlementUnitPrice = detailRes.cmCustomerLineData.settlementUnitPrice / 100;
          detailRes.cmCustomerLineData.deductionsScale = detailRes.cmCustomerLineData.deductionsScale / 100;

          switch (String(detailRes.cmCustomerLineData.payWay)) {
            case '1': // 预付全款
            case '2': // 预付 + 尾款账期
              detailRes.cmCustomerLineData.reciveTime = `离场日期后${detailRes.cmCustomerLineData.reciveTime}天`;
              if (detailRes.cmCustomerLineData.collectionTime) {
                detailRes.cmCustomerLineData.collection = `离场日期后${detailRes.cmCustomerLineData.collectionTime}天`;
              }
              break;
            case '3': // 预付 + 尾款月结
              detailRes.cmCustomerLineData.reciveTime = `${detailRes.cmCustomerLineData.reciveTime}个月后${detailRes.cmCustomerLineData.reciveTimeDay}天`;
              detailRes.cmCustomerLineData.collection = `${detailRes.cmCustomerLineData.collectionTime}个月后${detailRes.cmCustomerLineData.collectionTimeDay}天`;
              break;
            default:
              break;
          }
          this.detailData.base.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.carInfo.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.line.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.freight.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.income.tableData.title[0].unit = detailRes.cmCustomerLineData.priceEnumName || '';
          this.detailData.income.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.cost.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.costOut.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.settlement.tableData.data = detailRes.cmCustomerLineData;
          this.detailData.other.tableData.data = detailRes.cmCustomerLineData;

          if (this.id || this.$route.query.type) { // 审核

            detailRes.cmCustomerLineAuthData.settlementMethod = '按卸货重量';
            detailRes.cmCustomerLineAuthData.goodsUnitPrice = detailRes.cmCustomerLineAuthData.goodsUnitPrice / 100;
            detailRes.cmCustomerLineAuthData.settlementUnitPrice = detailRes.cmCustomerLineAuthData.settlementUnitPrice / 100;
            detailRes.cmCustomerLineAuthData.deductionsScale = detailRes.cmCustomerLineAuthData.deductionsScale / 100;
            switch (String(detailRes.cmCustomerLineAuthData.payWay)) {
              case '1': // 预付全款
              case '2': // 预付 + 尾款账期
                detailRes.cmCustomerLineAuthData.reciveTime = `离场日期后${detailRes.cmCustomerLineAuthData.reciveTime}天`;
                if (detailRes.cmCustomerLineAuthData.collectionTime) {
                  detailRes.cmCustomerLineAuthData.collection = `离场日期后${detailRes.cmCustomerLineAuthData.collectionTime}天`;
                }
                break;
              case '3': // 预付 + 尾款月结
                detailRes.cmCustomerLineAuthData.reciveTime = `${detailRes.cmCustomerLineAuthData.reciveTime}个月后${detailRes.cmCustomerLineAuthData.reciveTimeDay}天`;
                detailRes.cmCustomerLineAuthData.collection = `${detailRes.cmCustomerLineAuthData.collectionTime}个月后${detailRes.cmCustomerLineAuthData.collectionTimeDay}天`;
                break;
              default:
                break;
            }
            this.detailData.base.tableData.approveData = detailRes.cmCustomerLineAuthData;
            this.detailData.carInfo.tableData.approveData = detailRes.cmCustomerLineAuthData;
            this.detailData.line.tableData.approveData = detailRes.cmCustomerLineAuthData;
            this.detailData.freight.tableData.data = detailRes.cmCustomerLineAuthData;
            this.detailData.income.tableData.approveData = detailRes.cmCustomerLineAuthData;
            this.detailData.cost.tableData.approveData = detailRes.cmCustomerLineAuthData;
            this.detailData.costOut.tableData.approveData = detailRes.cmCustomerLineAuthData;
            this.detailData.settlement.tableData.approveData = detailRes.cmCustomerLineAuthData;
            this.detailData.other.tableData.approveData = detailRes.cmCustomerLineAuthData;

            // 删除经停点时
            const originLen = detailRes.cmCustomerLineData.subWayList.length;
            const changeLen = detailRes.cmCustomerLineAuthData.subWayList.length;
            const delNum = originLen - changeLen;
            if (delNum > 0) {
              for (let index = 0; index < delNum; index++) {
                this.detailData.line.tableData.approveData[`middleAddress${changeLen + index}`] = '删除';
                this.detailData.line.tableData.approveData[`middleLocation${changeLen + index}`] = '删除';
                this.detailData.line.tableData.approveData[`middleTime${changeLen + index}`] = '删除';
              }
            }
          }
        }
      }

    },
  },
  created () {
    if (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) {
      this.detailData.carInfo.label = '货物信息';
      this.detailData.carInfo.tableData.title.map((item, index) => {
        if (item.label === '车型要求') {
          this.detailData.carInfo.tableData.title.splice(index, 1);
        }
      });
    }

    if (this.userInfo.customerType === '8') {
      this.detailData.base.tableData.title = this.detailData.base.tableData.title.filter((item) => item.label !== '客户类型');
      this.detailData.carInfo.tableData.title = this.detailData.carInfo.tableData.title.filter((item) => item.label !== '计划数量');
      this.detailData.income.tableData.title = this.detailData.income.tableData.title.filter((item) => item.label !== '应付运费');
    }
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
